const AirportsTableColumns = [
    {
        id: "name_ar",
        labelAr: "الاسم (عربي)",
        labelEn: "Name (AR)",
        sortable: true,
    },
    {
        id: "name_en",
        labelAr: "الاسم (إنجليزي)",
        labelEn: "Name (EN)",
        sortable: true,
    },
    {
        id: "code",
        labelAr: "كود المطار",
        labelEn: "Airport Code",
        sortable: true,
    },
    {
        id: "country",
        labelAr: "الدولة",
        labelEn: "Country",
        sortable: true,
    },
    {
        id: "city",
        labelAr: "المدينة",
        labelEn: "City",
        sortable: true,
    },
    {
        id: "terminal_ar",
        labelAr: "الصالة (عربي)",
        labelEn: "Terminal (AR)",
        sortable: false,
    },
    {
        id: "terminal_en",
        labelAr: "الصالة (إنجليزي)",
        labelEn: "Terminal (EN)",
        sortable: false,
    },
    {
        id: "status",
        labelAr: "الحالة",
        labelEn: "Status",
        sortable: true,
    },
];

export default AirportsTableColumns;
